import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService, HttpClientService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { throwError } from 'rxjs';

import { HttpResponse, HttpHeaders } from '@angular/common/http';
import { UserWizardProductModel, ProductModel, BucketSummaryModel } from './shared';
import { DropdownModel } from 'lib/ng2-sapmp/src/ui-components/dropdown';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ANALYTICS_CONSTANTS } from 'config';
declare var ENV_PORTAL;
@Injectable()
export class UserWizardDataService {

    dropDownModel: DropdownModel;
    selectProperty: DropdownModel;
    productModel: ProductModel;
    userWizardProductModel: UserWizardProductModel;

    constructor(private utilityService: UtilityService,
        private httpClientService: HttpClientService, private router: Router,
        private adobeAnalyticsService: AdobeAnalyticsService) {
        this.selectProperty = new DropdownModel();
        this.selectProperty.name = 'Select';
        this.selectProperty.value = 'Select';
    }

    // Page Load
    createPageLoadProperties(itemList, url: string, title: string, pageName: string, virtualid?: string) {
        const dataLayer = {};
        if (virtualid !== undefined && virtualid === 'virtual') {
            dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] = ANALYTICS_CONSTANTS.ENVIRONMENT_URL + url;
        }
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = pageName;
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_MANAGE_USERS;
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_ABS_CHECKOUT_STEP] = title;
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Service';
        this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
    }

    handleError = (error) => {
        return throwError(error);
    }

    setUserWizard(obj) {
        sessionStorage.setItem('assign-wizard', JSON.stringify(obj));
    }

    getProductDetails(companyId: string, requestProductObject) {
        const url = this.utilityService.getEnvConfig().unAssignUrl + companyId + '/catalog/serviceOffers';
        return this.httpClientService.authorizedPut(url, requestProductObject).pipe(
       map((res: HttpResponse<any>) => {
            this.httpClientService.updateAuthorizationHeaders(res);
            return res.body;
        }),catchError( this.handleError ));
        /* let url = this.utilityService.getEnvConfig().getAssignUnassignProductDetails + companyId + '/inventory';
        return this.httpClientService.post(url, requestProductObject)
            .pipe(
       map((res: Response) => res.json()),catchError( this.handleError )); */
    }

    getMockUserList(servicePath) {
        return this.httpClientService.get(servicePath)
            .pipe(
       map((res: HttpResponse<any>) => res.body)
            ,catchError( this.handleError ));
    }

    getUserList(servicePath, body) {
        return this.httpClientService.authorizedPut(servicePath, body)
            .pipe(
       map((res: HttpResponse<any>) => {
                this.httpClientService.updateAuthorizationHeaders(res);
                return res.body;
            })
            ,catchError( this.handleError ));
    }

    public populateProductData(userWizard): UserWizardProductModel {
        this.userWizardProductModel = new UserWizardProductModel();
        this.userWizardProductModel.product = [];
        const productNameMap: Map<string, Set<string>> = new Map<string, Set<string>>();
        // if (userWizard.productList.dataJason.length > 0) {
        // Fetching Product Names and Fan List
        for (const product of userWizard.productList.dataJson) {
            this.productModel = new ProductModel();
            this.productModel.productName = product.name;
            this.productModel.dcmCode = product.code;
            /* this.productModel.totalLicenses = product.totalLicenses;
            this.productModel.totalLicensesInUse = product.totalLicensesInUse;
            this.productModel.totalLicensesAvailable = product.totalLicensesAvailable;
            this.productModel.fan = [];
            this.productModel.fan.push(this.selectProperty);
            product.accountSummaries.forEach((fanList, productName) => {
                this.dropDownModel = new DropdownModel();
                this.dropDownModel.name = fanList.accountClientId;
                this.dropDownModel.value = fanList.accountClientId;
                this.productModel.fan.push(this.dropDownModel);
            }); */
            this.userWizardProductModel.product.push(this.productModel);
        }
        // }
        return this.userWizardProductModel;
    }

    public removeUserWizard() {
        sessionStorage.removeItem('assign-wizard');
    }

    // This method applicable for Both action and Product
    public cancel(previousUrl) {
        this.removeUserWizard();
        this.router.navigate([previousUrl]);
    }


    /*public getCtnList(fan, selectedProductCode, companyId): any {
        return this.httpClientService.get(this.utilityService.getEnvConfig().getManageUserCtnUrl)
            .pipe(
       map(response => response.json()),catchError( this.handleError ));
    }

     public populateCtnList(responseCtnList, selectedProductName) {
         const ctnListModel = new ProductModel();
         ctnListModel.ctn = [];
         const ctnMap: Map<string, Set<string>> = new Map<string, Set<string>>();

         for (const ctnProduct of responseCtnList.dataJson) {
             if (ctnMap.has(ctnProduct.specName)) {
                 ctnMap.get(ctnProduct.specName).add(ctnProduct.billingClientId);
             } else {
                 ctnMap.set(ctnProduct.specName, new Set<string>());
                 ctnMap.get(ctnProduct.specName).add(ctnProduct.billingClientId);
             }
         }

         // Value, key
         ctnMap.forEach((ctnList, ctnProductname) => {
             if (selectedProductName === ctnProductname) {
                 ctnListModel.ctn.push(this.selectProperty);
                 ctnList.forEach(ctn => {
                     this.dropDownModel = new DropdownModel();
                     this.dropDownModel.name = ctn;
                     this.dropDownModel.value = ctn;
                     ctnListModel.ctn.push(this.dropDownModel);
                 });
             }
         });
         return ctnListModel.ctn;
     } */
    /* public getCtnList(requestCtn, companyId) {
       const headers = new Headers();
       headers.append('Accept', 'application/json');
       headers.append('Content-Type', 'application/json');
       headers.append('channel', 'premier');
       headers.append('portal', 'appmarket');
       headers.append('SERVICE-AUTH-TOKEN', sessionStorage.getItem('sapmp_jwtToken'));
       const url = this.utilityService.getEnvConfig().getManageUserCtnUrl + 032820172 + '/inventory/service';
       return this.httpClientService.put(url, requestCtn, headers)
           .pipe(
       map(response => response.json()),catchError( this.handleError ));
   }
   public populateCtnList(responseCtnList, selectedProductName) {
       const ctnListModel = new ProductModel();
       ctnListModel.ctn = [];
       // Value, key
       ctnListModel.ctn.push(this.selectProperty);
       responseCtnList.dataJson.forEach((ctn, index) => {
           if (selectedProductName === ctn.specName) {
               this.dropDownModel = new DropdownModel();
               this.dropDownModel.name = ctn.billingClientId;
               this.dropDownModel.value = ctn.clientId;
               ctnListModel.ctn.push(this.dropDownModel);
           }
       });
       return ctnListModel.ctn;
   } */

    public getFanAndCtnList(requestCtn, companyId, dcmCode) {
        const url = this.utilityService.getEnvConfig().unAssignUrl + companyId + '/stats/' + dcmCode + '?breakdown=true';
        return this.httpClientService.authorizedGet(url)
            .pipe(
       map((response: HttpResponse<any>) => {
                this.httpClientService.updateAuthorizationHeaders(response);
                return response.body;
            })
            ,catchError( this.handleError ));
        /*const url = this.utilityService.getEnvConfig().getProductFanCtnDetails;
        return this.httpClientService.get(url)
            .pipe(
       map(response => response.json()),catchError( this.handleError ));*/
    }

    public populateFan(userWizardModel: ProductModel, fanCtnresponse, dcmCode, type): ProductModel {
        const ctnMap: Map<string, BucketSummaryModel[]> = new Map<string, BucketSummaryModel[]>();
        if (fanCtnresponse) {
            userWizardModel.fan = [];
            userWizardModel.fan.push(this.selectProperty);
            fanCtnresponse.accountSummaries.forEach((fanList) => {
                if (fanList.accountClientId) {
                    if (type === 'ASSIGN') {
                        if (fanList.totalLicensesAvailable !== 0) {
                            this.dropDownModel = new DropdownModel();
                            this.dropDownModel.name = fanList.accountClientId;
                            this.dropDownModel.value = fanList.accountClientId;
                            ctnMap.set(fanList.accountClientId, fanList.bucketSummaries);
                            userWizardModel.fan.push(this.dropDownModel);
                        }
                    } else {
                        if (fanList.totalLicensesInUse !== 0) {
                            this.dropDownModel = new DropdownModel();
                            this.dropDownModel.name = fanList.accountClientId;
                            this.dropDownModel.value = fanList.accountClientId;
                            ctnMap.set(fanList.accountClientId, fanList.bucketSummaries);
                            userWizardModel.fan.push(this.dropDownModel);
                        }
                    }
                }
            });
        }
        userWizardModel.ctnMapObject = ctnMap;
        return userWizardModel;
    }
    /*  For Mock Purpose
    public populateFan(userWizardModel: ProductModel, fanCtnresponse, dcmCode): ProductModel {
        const ctnMap: Map<string, BucketSummaryModel[]> = new Map<string, BucketSummaryModel[]>();
        if (fanCtnresponse) {
            fanCtnresponse.forEach(element => {
                if (element.code === dcmCode) {
                    userWizardModel.fan = [];
                    userWizardModel.fan.push(this.selectProperty);
                    element.accountSummaries.forEach((fanList) => {
                        this.dropDownModel = new DropdownModel();
                        this.dropDownModel.name = fanList.accountClientId;
                        this.dropDownModel.value = fanList.accountClientId;
                        ctnMap.set(fanList.accountClientId, fanList.bucketSummaries);
                        userWizardModel.fan.push(this.dropDownModel);
                    });
                }
            });
        }
        userWizardModel.ctnMapObject = ctnMap;
        return userWizardModel;

    }*/

    /*processProduct() {
    let availabilityCount: number;
    if (this.productModelList.length === 1) {
      let requestBody = {};
      requestBody['clientId'] = this.productModelList[0].clientId;
      this.pageloaderService.setPageLoaderStatus(false);
      let url = this.utilityService.getEnvConfig().singleProductUrl + this.user.companyId + '/inventory/service';
      this.userWizardDataService.getUserList(url, requestBody).subscribe(respobj => {
        if (!!respobj.dataJson.length && respobj.dataJson.length > 0 && !!respobj.dataJson[0].totalLicensesInUse) {
          availabilityCount = respobj.dataJson[0].quantity - respobj.dataJson[0].totalLicensesInUse;
          this.productModelList[0].totalLicensesAvailable = availabilityCount.toString();
        }
        this.processProduct();
        this.pageloaderService.setPageLoaderStatus(true);
      }, error => {
        this.pageloaderService.setPageLoaderStatus(true);
        this.handleError(error);
      });
    } else {
      this.processProduct();
    }
    this.processProduct();
    this.userWizardModel.selectedProductList = [];
    this.userWizardModel.selectedProductList = (this.productModelList);
    this.userWizardService.addProductList(this.userWizardModel);
    this.router.navigate(['/manageUsers/users'], { relativeTo: this.activatedRoute });
  } */

    public populateCtnList(ctnBucketSummaries: BucketSummaryModel[], type) {
        const selectProperty = new DropdownModel();
        if (ctnBucketSummaries) {
            const ctnListModel = new ProductModel();
            ctnListModel.ctn = [];
            // Value, key
            selectProperty.name = 'Select';
            selectProperty.value = 'Select';
            ctnListModel.ctn.push(selectProperty);
            ctnBucketSummaries.forEach((ctnObject, index) => {
                if (type === 'ASSIGN') {
                    if (ctnObject.totalLicensesAvailable !== 0) {
                        this.dropDownModel = new DropdownModel();
                        this.dropDownModel.name = ctnObject.bucketClientId;
                        this.dropDownModel.value = ctnObject.bucketClientId;
                        ctnListModel.ctn.push(this.dropDownModel);
                    }
                } else {
                    if (ctnObject.totalLicensesInUse !== 0) {
                        this.dropDownModel = new DropdownModel();
                        this.dropDownModel.name = ctnObject.bucketClientId;
                        this.dropDownModel.value = ctnObject.bucketClientId;
                        ctnListModel.ctn.push(this.dropDownModel);
                    }
                }
            });
            return ctnListModel.ctn;
        }
    }

    public getClientId(requestCtn, companyId) {
        const url = this.utilityService.getEnvConfig().getManageUserCtnUrl + companyId + '/inventory/service';
        return this.httpClientService.authorizedPut(url, requestCtn)
            .pipe(
       map((response: HttpResponse<any>) => {
                this.httpClientService.updateAuthorizationHeaders(response);
                return response.body;
            })
            ,catchError( this.handleError ));
    }

    public populateClientId(responseClientId): any {
        const populateObject: any = { 'clientId': '', 'availabilityCount': '', 'licensegroupName': '', 'licenseInUse': '' };
        responseClientId.dataJson.forEach((clientIdObject) => {
            populateObject.clientId = clientIdObject.clientId;
            populateObject.availabilityCount = Number(clientIdObject.quantity) - Number(clientIdObject.totalLicensesInUse);
            populateObject.licenseInUse = Number(clientIdObject.totalLicensesInUse);
            populateObject.licensegroupName = clientIdObject.name;

        });
        return populateObject;
    }

    tokenRefresh() {
        this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
    }
}
